import { GetCwsTimeSaleInfoService } from './api-services/get-cws-time-sale-info.service';
import { RegistCwsTimeSaleInfoService } from './api-services/regist-cws-time-sale-info.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';

import { KYMW6501Component } from './kymw6501.component';
import { UpdateCwsTimeSaleInfoService } from './api-services/update-cws-time-sale-info.service';
import { DeleteCwsTimeSaleInfoService } from './api-services/delete-cws-time-sale-info.service';

/**
 * ECタイムセールマスタ設定画面 モジュール設定クラス
 *
 * @export KYMW6501Module
 * @class KYMW6501Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjInputModule,
    WjNavModule,
  ],
  declarations: [
    KYMW6501Component,
  ],
  providers: [
    GetCwsTimeSaleInfoService,
    RegistCwsTimeSaleInfoService,
    UpdateCwsTimeSaleInfoService,
    DeleteCwsTimeSaleInfoService
  ],
})
export class KYMW6501Module {

}
